/**
 * Redirects to the auth portal (auth-qa). Used for routes that are no longer
 * implemented in-app: 2FA/OTP login and update profile are handled by auth-qa only.
 */
import { useEffect } from 'react';
import { getAuthPortalLoginUrl } from '../utils/authPortal';
import { getAuthPortalRedirectUrlForTarget, resolveAuthPortalAccountRedirectTarget } from '../utils/authPortalAccountRedirect';
import { Box, Typography } from '@mui/material';

export default function AuthPortalRedirect({ type = 'login' }) {
  useEffect(() => {
    let cancelled = false;

    const redirect = async () => {
      if (type !== 'account') {
        window.location.href = getAuthPortalLoginUrl();
        return;
      }
      const target = await resolveAuthPortalAccountRedirectTarget();
      if (cancelled) {
        return;
      }
      const url = getAuthPortalRedirectUrlForTarget(target);
      if (target === 'login') {
        window.location.replace(url);
        return;
      }
      window.location.href = url;
    };

    redirect();
    return () => {
      cancelled = true;
    };
  }, [type]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh', flexDirection: 'column', gap: 2 }}>
      <Typography color="text.secondary">Redirecting to auth portal…</Typography>
    </Box>
  );
}
